import React, { FunctionComponent } from 'react';
import { useDispatch } from 'react-redux';
import GenericTable from 'components/Table/GenericTable';
import { TableColumn, TableColumn$RenderProps, RowActionsRender, TableRowData } from '@inplayer-org/inplayer-ui';
import moment from 'moment';

// utils
import { convertArrayToCamelCase } from 'utils/helpers';

// types
import { Report } from 'ducks/merchantDucks/items/types';

// actions
import { downloadReport } from 'ducks/merchantDucks/items/actions';

// components
import { CodesTableWrapper } from 'pages/MerchantPages/Assets/Codes/components/CodesTable';
import { CustomButton } from 'pages/MerchantPages/Assets/Price/containers/PriceOptions';

interface ReportTableData extends TableRowData {
  name: string;
  createdAt: number;
}

interface OwnProps {
  reports: {
    collection: Array<Report>;
    isFetching: boolean;
  };
}

type Props = OwnProps;

const ReportsTable: FunctionComponent<Props> = ({ reports: { collection, isFetching } }) => {
  const dispatch = useDispatch();
  const reportsCollection = convertArrayToCamelCase<Report, ReportTableData>(collection);

  const generateColumns = (): Array<TableColumn<ReportTableData>> => [
    {
      title: 'Name',
      key: 'name',
    },
    {
      title: 'Created at (UTC)',
      key: 'createdAt',
      render: ({ value }: TableColumn$RenderProps<ReportTableData, number>) =>
        value > 0
          ? moment(value * 1000)
              .utc()
              .format('YYYY/MM/DD HH:mm')
          : null,
    },
  ];

  const handleDownloadCodeReport = (filename: string) => () => {
    dispatch(downloadReport(filename, 'access-codes'));
  };

  const renderRowActions: RowActionsRender<ReportTableData> = ({ row }) => {
    return (
      <CustomButton buttonModifiers={['buttonLink']} type="button" onClick={handleDownloadCodeReport(row.name)}>
        Download
      </CustomButton>
    );
  };

  return (
    <CodesTableWrapper>
      <GenericTable<ReportTableData>
        columns={generateColumns()}
        data={reportsCollection}
        showLoader={isFetching}
        options={{ rowActions: renderRowActions }}
        noDataMessage="There are no available passcode reports."
      />
    </CodesTableWrapper>
  );
};
export default ReportsTable;
